import lodash from "lodash/core";
import _ from "lodash";

/**
 *
 * @param filters
 * @param dataList
 * @returns Filtered list of services. Computation done using
 * the filters object passed as param on the dataList.
 */
export function filterServices(filters, dataList) {

    // First filter by DP name
    let dpFilteredArr = dataList;
    if (filters.providerNameFilter !== null) {
        if (filters.providerNameFilter.value !== "all") {
            dpFilteredArr = lodash.filter(dpFilteredArr, {
                provider_name: filters.providerNameFilter.value
            });
        }
    }

    // Next filter by status
    let statusFilteredArr = dpFilteredArr;
    if (filters.statusFilter !== null) {
        if (filters.statusFilter.value !== "all") {
            statusFilteredArr = lodash.filter(statusFilteredArr, {
                integration_status: filters.statusFilter.value
            });
        }
    }

    // Next filter by sub-dp-type
    let subDPTypeFilteredArr = statusFilteredArr;
    if (filters.subDPTypeFilter !== null) {
        if (filters.subDPTypeFilter.value !== "all") {
            subDPTypeFilteredArr = lodash.filter(subDPTypeFilteredArr, {
                sub_type: filters.subDPTypeFilter.value
            });
        }
    }

    // filter by invoice_name
    let bgFilteredArr = subDPTypeFilteredArr;
    if (filters.invoiceNameFilter !== null) {
        if (filters.invoiceNameFilter.value !== "all") {
            bgFilteredArr = lodash.filter(bgFilteredArr, {
                invoice_name: filters.invoiceNameFilter.value
            });
        }
    }

    // filter by country
    let countryServicesArr = bgFilteredArr;
    if (filters.countryFilter !== null) {
        if (filters.countryFilter.length !== 0) {
            const isAll = filters.countryFilter.filter(f => f.value === 'all');
            if (isAll.length === 0) {
                const filterByCountry = (service) => {
                    if (service.associated_countries === null) {
                        return false;
                    } else {
                        const countryCodes = filters.countryFilter.map(x => x.value)
                        if (service.associated_countries.some(elem => countryCodes.includes(elem))) {
                                return true;
                        }
                    }
                }

                countryServicesArr = countryServicesArr.filter(filterByCountry);
            }
        }
    }

    let finalServicesArr = countryServicesArr;
    if (filters.verifiableElementsFilter !== null) {
        if (filters.verifiableElementsFilter.length !== 0) {
            const filterByElement = (service) => {
                if (service.verifiable_elements === null) {
                    return false;
                } else {
                    const inputFields = filters.verifiableElementsFilter.map(x => x.value)
                    if (service.verifiable_elements.some(elem => inputFields.includes(elem))) {
                        return true;
                    }
                }
            }

            finalServicesArr = finalServicesArr.filter(filterByElement);
        }
    }
    return finalServicesArr;
}

/**
 *
 * @param filters
 * @param dataList
 * @returns Filtered list of testcache records. Computation done using
 * the filters object passed as param on the dataList.
 */
export function filterTestcache(filters, dataList) {

    // First filter Country
    let testcacheFilteredArr = dataList;
    if (filters.testcacheCountryFilter !== null) {
        if (filters.testcacheCountryFilter.value !== "all") {
            testcacheFilteredArr = lodash.filter(testcacheFilteredArr, {
                countrycode:filters.testcacheCountryFilter.value
            });
        }
    }

    let finalFilteredTestcacheArr = testcacheFilteredArr;
    if (filters.testcacheDataSourceTypeFilter !== null) {
        if (filters.testcacheDataSourceTypeFilter.value !== "all") {
            finalFilteredTestcacheArr = lodash.filter(finalFilteredTestcacheArr, {
                data_source_type: filters.testcacheDataSourceTypeFilter.value
            });
        }
    }

    return finalFilteredTestcacheArr;
}

/**
 * @param filters
 * @param dataList
 * @returns Filtered list of KYB testcache records. Computation done using
 * the filters object passed as param on the dataList.
 */
export function filterKYBTestcache(filters, dataList) {

    // First filter by Country
    let kybTestcacheFilteredArr = dataList;
    if (filters.kybTestcacheCountryFilter !== null) {
        if (filters.kybTestcacheCountryFilter.value !== "all") {
            kybTestcacheFilteredArr = lodash.filter(kybTestcacheFilteredArr, {
                countrycode: filters.kybTestcacheCountryFilter.value
            });
        }
    }

    // Then filter by Data Source
    let finalFilteredKYBTestcacheArr = kybTestcacheFilteredArr;
    if (filters.kybTestcacheDataSourceFilter !== null) {
        if (filters.kybTestcacheDataSourceFilter.value !== "all") {
            finalFilteredKYBTestcacheArr = lodash.filter(finalFilteredKYBTestcacheArr, {
                datasource: filters.kybTestcacheDataSourceFilter.value
            });
        }
    }

    return finalFilteredKYBTestcacheArr;
}

/**
 * @param val - the keyword being searched.
 * @param dataList - the array of objects on the list page.
 * @returns This function takes in an array of objects and filters the
 * dataList on all available attributes of the objects.
 */
export function listPageGlobalFilter(val, dataList) {

    let filteredArr = [];
    const normalize = str => _.toLower(_.deburr(str))

    const includesValue = (val, obj) => {
        const search = normalize(val)
        return _.some(obj, v => normalize(v).includes(search))
    }
    dataList.forEach(s => {
        if (includesValue(val, s)) {
            filteredArr.push(s)
        }
    })
    return filteredArr;
}
